var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.542 6.66667C12.748 6.66667 12.9427 6.57133 13.0687 6.40867C13.1947 6.246 13.2387 6.034 13.188 5.83467C12.9807 5.02333 12.558 4.282 11.966 3.69L9.64267 1.36667C8.76133 0.485333 7.58933 0 6.34267 0H3.33267C1.49533 0 0 1.49533 0 3.33333V12.6667C0 14.5047 1.49533 16 3.33333 16H5.33333C5.70133 16 6 15.7013 6 15.3333C6 14.9653 5.70133 14.6667 5.33333 14.6667H3.33333C2.23067 14.6667 1.33333 13.7693 1.33333 12.6667V3.33333C1.33333 2.23067 2.23067 1.33333 3.33333 1.33333H6.34333C6.452 1.33333 6.56 1.33867 6.66667 1.34867V4.66667C6.66667 5.76933 7.564 6.66667 8.66667 6.66667H12.542ZM8 4.66667V1.77267C8.25267 1.918 8.488 2.098 8.7 2.31L11.0233 4.63333C11.2327 4.84267 11.412 5.07867 11.5587 5.33333H8.66667C8.29933 5.33333 8 5.034 8 4.66667ZM15.4147 7.91933C14.6587 7.16333 13.3413 7.16333 12.586 7.91933L8.11467 12.3907C7.61133 12.894 7.33333 13.564 7.33333 14.2767V15.334C7.33333 15.702 7.632 16.0007 8 16.0007H9.05733C9.77 16.0007 10.4393 15.7227 10.9427 15.2193L15.414 10.748C15.792 10.37 16 9.868 16 9.33333C16 8.79867 15.792 8.29667 15.4147 7.91933ZM14.4713 9.80467L9.99933 14.276C9.748 14.528 9.41333 14.6667 9.05667 14.6667H8.666V14.276C8.666 13.92 8.80467 13.5853 9.05667 13.3333L13.5287 8.862C13.78 8.61 14.2193 8.61 14.4713 8.862C14.5973 8.98733 14.6667 9.15467 14.6667 9.33333C14.6667 9.512 14.5973 9.67867 14.4713 9.80467Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_1137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.b323a74f66de8616fdbcf6b2c6d139d1.svg";
export { ForwardRef as ReactComponent };